module.exports = __webpack_public_path__ + "img/Logo.bece0681.png";